import { render } from "./TransactionsTable.vue?vue&type=template&id=6471faf9"
import script from "./TransactionsTable.vue?vue&type=script&lang=js"
export * from "./TransactionsTable.vue?vue&type=script&lang=js"

import "./TransactionsTable.vue?vue&type=style&index=0&id=6471faf9&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TransactionsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6471faf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6471faf9', __exports__)) {
    console.log('reload')
    api.reload('6471faf9', __exports__)
  }
  
  module.hot.accept("./TransactionsTable.vue?vue&type=template&id=6471faf9", () => {
    console.log('re-render')
    api.rerender('6471faf9', render)
  })

}


export default __exports__